// ABOUTME: Timeline component for the Event log action.
// ABOUTME: Displays a cyan-styled timeline entry with the shortened message of an order event.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import Text from "../../../../theme/text/Text";
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';

const TimeLineEvent = (props) => {
    const theme = useTheme();
    const {t,i18n} = useTranslation();
    const colors = tokens(theme.palette.mode);

    return(
        <Box
            sx={{
                flex:1,
                flexShrink:0,
                "@media screen and (max-width: 47.9375em)" : {
                    display:"flex",
                    flexDirection:"column",
                }
            }}
        >
            <Box sx={{ mb:0.5 }}>
                <Box
                    sx={{
                        display:"flex",
                        justifyContent:"space-between",
                    }}
                >
                    <Text bold>{t("event")}</Text>
                    <Box>
                        <Text>{new Date(props.createdAt).toLocaleDateString(i18n.language)}</Text>&nbsp;
                        <Text light>{new Date(props.createdAt).toLocaleTimeString(i18n.language, { hour: '2-digit', minute: '2-digit' })}</Text>
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    px:2,
                    display:"flex",
                    alignItems:'flex-start',
                    gap:1.5,
                    width:1,
                    borderRadius:4,
                    py:1.5,
                    background:theme.palette.mode === "dark" ? colors.cyan[200] : colors.cyan[100],
                    "@media screen and (max-width: 47.9375em)" : {
                        width:250,
                        flex:1,
                    }
                }}
            >
                <Box
                    sx={{
                        display:"flex",
                        alignItems:'center',
                        justifyContent:'center',
                        color:colors.cyan[400],
                        borderRadius:4,
                        flexShrink:0,
                        height:32,
                        width:32,
                        background:theme.palette.mode === "dark" ? colors.cyan[300] : colors.cyan[200],
                    }}
                >
                    <EventNoteOutlinedIcon/>
                </Box>
                <Box>
                    <Text semibold>{props.userName || t("fulfilment")}</Text><br/>
                    <Text light>{props.description}</Text>
                </Box>
            </Box>
        </Box>
    )
}

export default TimeLineEvent;
